import { useTranslation } from 'react-i18next';
import OrderingTimeSlots from '../../ordering-time-slots/ordering-time-slots.component';
import { getLocationOrderingInfo } from 'pages/locations/locations.utils';

const PickupOrderHours = ({ store }) => {
  const { t } = useTranslation();
  const { pickupOrderHours, timeZone, pickupOffDays } = store;
  const { durations } = getLocationOrderingInfo(
    pickupOrderHours,
    timeZone,
    pickupOffDays,
  );

  return (
    <OrderingTimeSlots
      title={t('locations.card.todayOrderingHours.pickup')}
      durations={durations}
      titleTestId="OrderHours.OrderingTimeSlots.Title"
    />
  );
};

export default PickupOrderHours;
